module.exports = __webpack_public_path__ + "media/assets/images/flags/lk-e5058928681e29fc6a4fc35d347d6ec7.svg";